import xs from "xstream"
import { div, label, input, button, select, span, hr, br } from "@cycle/dom"
import * as R from "ramda"

import {
  CheckResult,
  RecessForm,
} from "../../../../interface"

import {
  createTextArea,
  createTextInput,
  dateOptions,
} from "../../../common"

const drawRecessType = (userForm: RecessForm, errorCheck: any, readOnly: boolean) => {
  const err: CheckResult = R.propOr({}, "recess", errorCheck)
  const valid = (err.check || readOnly) ? "" : "is-invalid"

  return div(".row.row-cols-auto.g-3.align-items-center.mt-0.mt-md-2",[
    div(".col-12.col-md-3.mt-md-0", [
      div(".form-check", [
        input(`#r2.form-check-input.${valid}`, {
          attrs: { type: "radio", name: "recess", value: "留学・休会を希望しない", disabled: readOnly },
          props: { checked: R.prop("recess", userForm) === "留学・休会を希望しない" },
        }),
        label(".form-check-label", { attrs: { for: "r2" } }, [
          "留学・休会を希望しない"
        ]),
      ]),
    ]),
    div(".col-12.col-md-3.mt-md-0", [
      div(".form-check", [
        input(`#r1.form-check-input.${valid}`, {
          attrs: { type: "radio", name: "recess", value: "留学・休会を希望する", disabled: readOnly },
          props: { checked: R.prop("recess", userForm) === "留学・休会を希望する" },
        }),
        label(".form-check-label", { attrs: { for: "r1" } }, [
          "留学・休会を希望する"
        ]),
      ]),
    ]),
    div(".col-12.col-md-3.mt-md-0", [
      div(".form-check", [
        input(`#r3.form-check-input.${valid}`, {
          attrs: { type: "radio", name: "recess", value: "休会", disabled: readOnly },
          props: { checked: R.prop("recess", userForm) === "休会" },
        }),
        label(".form-check-label", { attrs: { for: "r3" } }, [
          "休会"
        ]),
      ]),
    ]),
    err.check ? null : div(".invalid-feedback.d-block", [err.message]),
  ])
}

const drawPeriodInput = (userForm: RecessForm, errorCheck: any, readOnly: boolean) => {
  if (!userForm) {
    return null
  }
  const err: CheckResult = R.propOr({}, "fromYear", errorCheck)
  const valid = (err.check || readOnly) ? "" : ".border-danger"
  const sYear = new Date().getFullYear()
  const monthOptions = dateOptions(1, 12, true)
  const yearOptions = dateOptions(sYear, 10, true)

  const monthOptionsTo = dateOptions(1, 12, true)
  const yearOptionsTo = dateOptions(sYear, 10, true)
  return div(".col-md-6", [
    label(".form-label", ["留学・休会期間※"]),
    div(".d-flex.flex-wrap.flex-md-nowrap.align-items-end", [
      div(".col-6.col-md-3.d-flex.align-items-end", [
        select(
          `.form-select.form-select-sm${valid}`,
          { attrs: { name: "fromYear", disabled: readOnly } },
          yearOptions(userForm.fromYear),
        ),
        span(["年"]),
      ]),
      div(".col-6.col-md-3.d-flex.align-items-end", [
        select(
          `.form-select.form-select-sm${valid}`,
          { attrs: { name: "fromMonth", disabled: readOnly } },
          monthOptions(userForm.fromMonth),
        ),
        span(["月"]),
      ]),
      div(".col-12.col-md-1.flex-md-shrink-1.text-center", ["～"]),
      div(".col-6.col-md-3.d-flex.align-items-end", [
        select(
          `.form-select.form-select-sm${valid}`,
          { attrs: { name: "toYear", disabled: readOnly } },
          yearOptionsTo(userForm.toYear),
        ),
        span(["年"]),
      ]),
      div(".col-6.col-md-3.d-flex.align-items-end", [
        select(
          `.form-select.form-select-sm${valid}`,
          { attrs: { name: "toMonth", disabled: readOnly } },
          monthOptionsTo(userForm.toMonth),
        ),
        span(["月"]),
      ])
    ]),
    div(".form-text", ["※予定で結構です。"]),
    err.check ? null : div(".invalid-feedback.d-block", [err.message]),
  ])
}
export const view = (
  userForm$: xs<RecessForm>,
  errorCheck$: xs<any>,
  zipMsg$: xs<string | null>,
  readOnly = false,
) =>
  xs
    .combine(userForm$, errorCheck$, zipMsg$)
    .map(
      ([userForm, errorCheck, _zipMsg]: [
        RecessForm,
        any,
        string | null,
      ]) => {
        const disabled = R.find(
          (arr) => arr[1].check === false,
          R.toPairs(errorCheck),
        )
          ? true
          : false
        const gutter = readOnly ? "" : ".mt-2"
        const isNotRecess = R.prop("recess", userForm) === "留学・休会を希望しない"
        const noRecess = R.propOr("", "recess", userForm) === ""
        const t1Class = ".fw-bold" // noRecess ? ".form-bold" : isNotRecess ? ".form-text" : ".fw-bold"
        const t2Class = noRecess ? ".form-text" : isNotRecess ? ".fw-bold" : ".form-text"
        return div([
          div(".form.mt-1", [
            div(`.row${gutter}`, [
              readOnly ? null : div(".px-2", [
                div(".border.border-danger.border-2.p-2", [
                  div(".fw-bold", ["休会について　必ずご一読ください"]),
                  div(`${t1Class}`, ["※本会では当該年度迄の年会費納入を確認の上、休会申請を受理する定めになっております。"]),
                  div(`${t1Class}`, ["※休会は年度単位(4月~翌年3月)となっており、休会中の年会費は発生しません。"]),
                  div(`${t1Class}`, ["※休会中は郵送物の配送、学会誌の閲覧を含むWeb会員証へのログインは出来ません。"]),
                  div(`${t1Class}`, ["※休会手続が完了した後、留学期間終了予定時期に達しても自動的に復会のお手続きを行うことはありません。ご帰国等による本会への復帰希望に際しては必ず日本生殖医学会事務局へEメールまたはFAXにてご連絡ください。"]),
                  div(`${t2Class}`, [
                    "※海外在住でかつ本会会員を継続される場合は、郵送物を海外へ配送いたしますが、年会費は下記のとおり変更になります。",
                    br(),
                    "医師（医師免許証を有する会員）年会費：13,000円",
                    br(),
                    "獣医師、研究者、または医師以外で医療に従事する者等の年会費：11,000円",
                  ]),
                ]),
              ]),
            ]),
            readOnly ? null : div(".row", [
              div(".col-md-6.caution", ["※は必須入力です。"]),
            ]),
            div(`.row${gutter}`, [
              label(".form-label.fw-bold.mt-2.mb-0", ["留学・休会※"]),
              drawRecessType(userForm, errorCheck, readOnly),
            ]),
            div(`.row${gutter}`, [drawPeriodInput(userForm, errorCheck, readOnly)]),
            isNotRecess
              ? null
              : div([
                div(`.row${gutter}`, [
                  createTextArea("rfReason", readOnly)(userForm, errorCheck),
                ]),
                div(`.row${gutter}`, [
                  createTextArea("contactInfo", readOnly)(userForm, errorCheck),
                ]),
              ]),
            isNotRecess
              ? div([
                div(`.row${gutter}`, [
                  label(".form-label.fw-bold.mb-0", ["留学中送付先"]),
                  createTextInput("rfCountry", readOnly)(userForm, errorCheck),
                ]),
                div(`.row${gutter}`, [createTextInput("rfZip", readOnly)(userForm, errorCheck)]),
                div(`.row${gutter}`, [createTextInput("rfAddr1", readOnly)(userForm, errorCheck)]),
                div(`.row${gutter}`, [createTextInput("rfAddr2", readOnly)(userForm, errorCheck)]),
                div(`.row${gutter}`, [createTextInput("rfSection", readOnly)(userForm, errorCheck)]),
              ])
              : null,
              div(`.row${gutter}`, [
                createTextArea("bikou", readOnly)(userForm, errorCheck),
              ]),
            div(".d-grid.gap-3.mt-4", [
              div(".col.col-md-4", [
                readOnly
                  ? button(
                    "#btnSend.btn.btn-danger.w-100",
                    { props: { disabled: disabled } },
                    ["留学・休会申請を行う"],
                  )
                  : button(
                    "#btnConfirm.btn.btn-primary.w-100",
                    { props: { disabled: disabled } },
                    ["申請内容を確認する"],
                  ),
              ]),
              div(".col.col-md-4", [
                button( "#btnReturn.btn.btn-success.w-100", ["戻る"]),
              ]),
            ]),
          ]),
        ])
      },
    )
